import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Inject, NgModule, Optional } from '@angular/core';
import * as i1$1 from '@ngrx/effects';
import { createEffect, ofType, EffectsModule } from '@ngrx/effects';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { throwError, of } from 'rxjs';
import { catchError, filter, switchMap } from 'rxjs/operators';
import * as i1$2 from '@ngrx/store';
import { createAction, props } from '@ngrx/store';
import * as i2 from '@panamax/app-state';
import * as i3 from '@panamax/websocket';

const NGRX_FILESHARE_LIB_CONFIG = new InjectionToken('NGRX_FILESHARE_LIB_CONFIG');

class HttpClientService {
    constructor(config, http) {
        this.config = config;
        this.http = http;
    }
    /**
     * @param path relative path of the resource
     * @param traceContext optional trace context
     */
    get(path, traceContext) {
        const url = `${this.config.apiUrl}/${path}`;
        const requestOptions = {
            headers: new HttpHeaders({
                'content-type': 'application/json',
                'consumer-id': 'ecomr4',
                'trace-context': traceContext,
            }),
        };
        return this.http
            .get(url, {
            ...requestOptions,
        })
            .pipe(catchError(this.handleError));
    }
    /**
     * @param path relative path of the resource
     * @param body the body of the put call
     * @param params optional additional HttpParams
     */
    put(path, body, params) {
        const url = `${this.config.apiUrl}/${path}`;
        return this.http
            .put(url, body || {}, {
            params,
        })
            .pipe(catchError(this.handleError));
    }
    /**
     * @param path relative path of the resource
     * @param traceContext optional trace context
     */
    patch(path, traceContext) {
        const url = `${this.config.apiUrl}/${path}`;
        const requestOptions = {
            headers: new HttpHeaders({
                'content-type': 'application/json',
                'consumer-id': 'ecomr4',
                'trace-context': traceContext,
            }),
        };
        return this.http
            .patch(url, {
            ...requestOptions,
        })
            .pipe(catchError(this.handleError));
    }
    patchBody(path, body) {
        const url = `${this.config.apiUrl}/${path}`;
        const requestOptions = {
            headers: new HttpHeaders({
                'content-type': 'application/json',
                'consumer-id': 'ecomr4',
            }),
        };
        return this.http
            .patch(url, {
            body,
        })
            .pipe(catchError(this.handleError));
    }
    /**
     * @param path relative path of the resource
     * @param body the body of the post call
     * @param params optional additional HttpParams
     */
    post(path, body, params) {
        const url = `${this.config.apiUrl}/${path}`;
        return this.http
            .post(url, body || {}, {
            params,
        })
            .pipe(catchError(this.handleError));
    }
    /**
     * @param path relative path of the resource
     * @param body the body of the delete call
     */
    delete(path, body) {
        const url = `${this.config.apiUrl}/${path}`;
        return this.http
            .request('delete', url, { body })
            .pipe(catchError(this.handleError));
    }
    /**
     * @param errror - error response received from the api request
     * @returns empty Observable
     */
    handleError(error) {
        return throwError(error);
    }
}
HttpClientService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HttpClientService, deps: [{ token: NGRX_FILESHARE_LIB_CONFIG }, { token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
HttpClientService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HttpClientService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HttpClientService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [NGRX_FILESHARE_LIB_CONFIG]
                }] }, { type: i1.HttpClient }]; } });

const sharePDPViaEmail = createAction('[NGRXTrace - File Share] Share PDP Via Email', props());
const sharePDPViaEmailSuccess = createAction('[NGRXTrace - File Share] Share PDP Via Email Success', props());
const sharePDPViaEmailFail = createAction('[NGRXTrace - File Share] Share PDP Via Email Fail', props());
const SHARE_PDP_EMAIL_ACTIONS = {
    sharePDPViaEmail,
    sharePDPViaEmailSuccess,
    sharePDPViaEmailFail,
};

const TRACE_CONTEXT = {
    sharePDPViaEmail: 'sharePDPViaEmail',
    shareReviewOrderViaEmail: 'shareReviewOrderViaEmail',
    shareOrderConfirmationViaEmail: 'shareOrderConfirmationViaEmail',
    shareSubmittedOrderViaEmail: 'shareSubmittedOrderViaEmail',
    shareProductCompareViaEmail: 'shareProductCompareViaEmail',
};

class SharePDPViaEmailService {
    constructor(serviceHandler) {
        this.serviceHandler = serviceHandler;
    }
    sharePDPViaEmail(data) {
        return this.serviceHandler.post('sharePDP', data)?.pipe(filter((resp) => !!resp), catchError((error) => throwError(error)));
    }
}
SharePDPViaEmailService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SharePDPViaEmailService, deps: [{ token: HttpClientService }], target: i0.ɵɵFactoryTarget.Injectable });
SharePDPViaEmailService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SharePDPViaEmailService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SharePDPViaEmailService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HttpClientService }]; } });

class SharePDPViaEmailEffects {
    constructor(actions$, sharePDPViaEmailService) {
        this.actions$ = actions$;
        this.sharePDPViaEmailService = sharePDPViaEmailService;
        this.sharePDPViaEmail$ = createEffect(() => this.actions$.pipe(ofType(SHARE_PDP_EMAIL_ACTIONS.sharePDPViaEmail), switchMap((params) => this.sharePDPViaEmailService.sharePDPViaEmail(params.data).pipe(switchMap((response) => [
            SHARE_PDP_EMAIL_ACTIONS.sharePDPViaEmailSuccess({
                response,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.sharePDPViaEmail,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                    },
                },
            }),
        ]), catchError((err) => {
            const error = { status: err.status, message: err.message };
            return of(SHARE_PDP_EMAIL_ACTIONS.sharePDPViaEmailFail({
                error,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.sharePDPViaEmail,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                    },
                },
            }));
        })))));
    }
}
SharePDPViaEmailEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SharePDPViaEmailEffects, deps: [{ token: i1$1.Actions }, { token: SharePDPViaEmailService }], target: i0.ɵɵFactoryTarget.Injectable });
SharePDPViaEmailEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SharePDPViaEmailEffects, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SharePDPViaEmailEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.Actions }, { type: SharePDPViaEmailService }]; } });

const shareReviewOrderViaEmail = createAction('[NGRXTrace - File Share] Share Review Order Via Email', props());
const shareReviewOrderViaEmailSuccess = createAction('[NGRXTrace - File Share] Share Review Order Via Email Success', props());
const shareReviewOrderViaEmailFail = createAction('[NGRXTrace - File Share] Share Review Order Via Email Fail', props());
const SHARE_REVIEW_ORDER_EMAIL_ACTIONS = {
    shareReviewOrderViaEmail,
    shareReviewOrderViaEmailSuccess,
    shareReviewOrderViaEmailFail,
};

class ShareReviewOrderViaEmailService {
    constructor(serviceHandler) {
        this.serviceHandler = serviceHandler;
    }
    shareReviewOrderViaEmail(data) {
        return this.serviceHandler.post('shareReviewOrder', data)?.pipe(filter((resp) => !!resp), catchError((error) => throwError(error)));
    }
}
ShareReviewOrderViaEmailService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShareReviewOrderViaEmailService, deps: [{ token: HttpClientService }], target: i0.ɵɵFactoryTarget.Injectable });
ShareReviewOrderViaEmailService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShareReviewOrderViaEmailService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShareReviewOrderViaEmailService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HttpClientService }]; } });

class ShareReviewOrderViaEmailEffects {
    constructor(actions$, shareReviewOrderViaEmailService) {
        this.actions$ = actions$;
        this.shareReviewOrderViaEmailService = shareReviewOrderViaEmailService;
        this.shareReviewOrderViaEmail$ = createEffect(() => this.actions$.pipe(ofType(SHARE_REVIEW_ORDER_EMAIL_ACTIONS.shareReviewOrderViaEmail), switchMap((params) => this.shareReviewOrderViaEmailService
            .shareReviewOrderViaEmail(params.data)
            .pipe(switchMap((response) => [
            SHARE_REVIEW_ORDER_EMAIL_ACTIONS.shareReviewOrderViaEmailSuccess({
                response,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.shareReviewOrderViaEmail,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                    },
                },
            }),
        ]), catchError((err) => {
            const error = { status: err.status, message: err.message };
            return of(SHARE_REVIEW_ORDER_EMAIL_ACTIONS.shareReviewOrderViaEmailFail({
                error,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.shareReviewOrderViaEmail,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                    },
                },
            }));
        })))));
    }
}
ShareReviewOrderViaEmailEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShareReviewOrderViaEmailEffects, deps: [{ token: i1$1.Actions }, { token: ShareReviewOrderViaEmailService }], target: i0.ɵɵFactoryTarget.Injectable });
ShareReviewOrderViaEmailEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShareReviewOrderViaEmailEffects, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShareReviewOrderViaEmailEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.Actions }, { type: ShareReviewOrderViaEmailService }]; } });

const shareOrderConfirmationViaEmail = createAction('[NGRXTrace - File Share] Share Order Confirmation Via Email', props());
const shareOrderConfirmationViaEmailSuccess = createAction('[NGRXTrace - File Share] Share Order Confirmation Via Email Success', props());
const shareOrderConfirmationViaEmailFail = createAction('[NGRXTrace - File Share] Share Order Confirmation Via Email Fail', props());
const SHARE_ORDER_CONFIRMATION_EMAIL_ACTIONS = {
    shareOrderConfirmationViaEmail,
    shareOrderConfirmationViaEmailSuccess,
    shareOrderConfirmationViaEmailFail,
};

class ShareOrderConfirmationViaEmailService {
    constructor(serviceHandler) {
        this.serviceHandler = serviceHandler;
    }
    shareOrderConfirmationViaEmail(data) {
        return this.serviceHandler.post('shareOrderConfirmation', data)?.pipe(filter((resp) => !!resp), catchError((error) => throwError(error)));
    }
}
ShareOrderConfirmationViaEmailService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShareOrderConfirmationViaEmailService, deps: [{ token: HttpClientService }], target: i0.ɵɵFactoryTarget.Injectable });
ShareOrderConfirmationViaEmailService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShareOrderConfirmationViaEmailService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShareOrderConfirmationViaEmailService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HttpClientService }]; } });

class ShareOrderConfirmationViaEmailEffects {
    constructor(actions$, shareOrderConfirmationViaEmailService) {
        this.actions$ = actions$;
        this.shareOrderConfirmationViaEmailService = shareOrderConfirmationViaEmailService;
        this.shareOrderConfirmationViaEmail$ = createEffect(() => this.actions$.pipe(ofType(SHARE_ORDER_CONFIRMATION_EMAIL_ACTIONS.shareOrderConfirmationViaEmail), switchMap((params) => this.shareOrderConfirmationViaEmailService
            .shareOrderConfirmationViaEmail(params.data)
            .pipe(switchMap((response) => [
            SHARE_ORDER_CONFIRMATION_EMAIL_ACTIONS.shareOrderConfirmationViaEmailSuccess({
                response,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.shareOrderConfirmationViaEmail,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                    },
                },
            }),
        ]), catchError((err) => {
            const error = { status: err.status, message: err.message };
            return of(SHARE_ORDER_CONFIRMATION_EMAIL_ACTIONS.shareOrderConfirmationViaEmailFail({
                error,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.shareOrderConfirmationViaEmail,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                    },
                },
            }));
        })))));
    }
}
ShareOrderConfirmationViaEmailEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShareOrderConfirmationViaEmailEffects, deps: [{ token: i1$1.Actions }, { token: ShareOrderConfirmationViaEmailService }], target: i0.ɵɵFactoryTarget.Injectable });
ShareOrderConfirmationViaEmailEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShareOrderConfirmationViaEmailEffects, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShareOrderConfirmationViaEmailEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.Actions }, { type: ShareOrderConfirmationViaEmailService }]; } });

const shareSubmittedOrderViaEmail = createAction('[NGRXTrace - File Share] Share Submitted Order Via Email', props());
const shareSubmittedOrderViaEmailSuccess = createAction('[NGRXTrace - File Share] Share Submitted Order Via Email Success', props());
const shareSubmittedOrderViaEmailFail = createAction('[NGRXTrace - File Share] Share Submitted Order Via Email Fail', props());
const SHARE_SUBMITTED_ORDER_EMAIL_ACTIONS = {
    shareSubmittedOrderViaEmail,
    shareSubmittedOrderViaEmailSuccess,
    shareSubmittedOrderViaEmailFail,
};

class ShareSubmittedOrderViaEmailService {
    constructor(serviceHandler) {
        this.serviceHandler = serviceHandler;
    }
    shareSubmittedOrderViaEmail(data) {
        return this.serviceHandler.post('shareOrderConfirmation', data)?.pipe(filter((resp) => !!resp), catchError((error) => throwError(error)));
    }
}
ShareSubmittedOrderViaEmailService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShareSubmittedOrderViaEmailService, deps: [{ token: HttpClientService }], target: i0.ɵɵFactoryTarget.Injectable });
ShareSubmittedOrderViaEmailService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShareSubmittedOrderViaEmailService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShareSubmittedOrderViaEmailService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HttpClientService }]; } });

class ShareSubmittedOrderViaEmailEffects {
    constructor(actions$, shareSubmittedOrderViaEmailService) {
        this.actions$ = actions$;
        this.shareSubmittedOrderViaEmailService = shareSubmittedOrderViaEmailService;
        this.shareSubmittedOrderViaEmail$ = createEffect(() => this.actions$.pipe(ofType(SHARE_SUBMITTED_ORDER_EMAIL_ACTIONS.shareSubmittedOrderViaEmail), switchMap((params) => this.shareSubmittedOrderViaEmailService
            .shareSubmittedOrderViaEmail(params.data)
            .pipe(switchMap((response) => [
            SHARE_SUBMITTED_ORDER_EMAIL_ACTIONS.shareSubmittedOrderViaEmailSuccess({
                response,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.shareSubmittedOrderViaEmail,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                    },
                },
            }),
        ]), catchError((err) => {
            const error = { status: err.status, message: err.message };
            return of(SHARE_SUBMITTED_ORDER_EMAIL_ACTIONS.shareSubmittedOrderViaEmailFail({
                error,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.shareSubmittedOrderViaEmail,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                    },
                },
            }));
        })))));
    }
}
ShareSubmittedOrderViaEmailEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShareSubmittedOrderViaEmailEffects, deps: [{ token: i1$1.Actions }, { token: ShareSubmittedOrderViaEmailService }], target: i0.ɵɵFactoryTarget.Injectable });
ShareSubmittedOrderViaEmailEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShareSubmittedOrderViaEmailEffects, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShareSubmittedOrderViaEmailEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.Actions }, { type: ShareSubmittedOrderViaEmailService }]; } });

const shareProductCompareViaEmail = createAction('[NGRXTrace - File Share] Share Product Compare Via Email', props());
const shareProductCompareViaEmailSuccess = createAction('[NGRXTrace - File Share] Share Product Compare Via Email Success', props());
const shareProductCompareViaEmailFail = createAction('[NGRXTrace - File Share] Share Product Compare Via Email Fail', props());
const SHARE_PRODUCT_COMPARE_EMAIL_ACTIONS = {
    shareProductCompareViaEmail,
    shareProductCompareViaEmailSuccess,
    shareProductCompareViaEmailFail,
};

class ShareProductCompareViaEmailService {
    constructor(serviceHandler) {
        this.serviceHandler = serviceHandler;
    }
    shareProductCompareViaEmail(data) {
        const ext = data?.fileName?.split('.').pop()?.toLowerCase();
        let endpoint = 'shareProductCompareCSV';
        if (ext === 'pdf') {
            endpoint = 'shareProductComparePDF';
        }
        return this.serviceHandler.post(endpoint, data)?.pipe(filter((resp) => !!resp), catchError((error) => throwError(error)));
    }
}
ShareProductCompareViaEmailService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShareProductCompareViaEmailService, deps: [{ token: HttpClientService }], target: i0.ɵɵFactoryTarget.Injectable });
ShareProductCompareViaEmailService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShareProductCompareViaEmailService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShareProductCompareViaEmailService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HttpClientService }]; } });

class ShareProductCompareViaEmailEffects {
    constructor(actions$, shareProductCompareViaEmailService) {
        this.actions$ = actions$;
        this.shareProductCompareViaEmailService = shareProductCompareViaEmailService;
        this.shareProductCompareViaEmail$ = createEffect(() => this.actions$.pipe(ofType(SHARE_PRODUCT_COMPARE_EMAIL_ACTIONS.shareProductCompareViaEmail), switchMap((params) => this.shareProductCompareViaEmailService
            .shareProductCompareViaEmail(params.data)
            .pipe(switchMap((response) => [
            SHARE_PRODUCT_COMPARE_EMAIL_ACTIONS.shareProductCompareViaEmailSuccess({
                response,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.shareProductCompareViaEmail,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                    },
                },
            }),
        ]), catchError((err) => {
            const error = { status: err.status, message: err.message };
            return of(SHARE_PRODUCT_COMPARE_EMAIL_ACTIONS.shareProductCompareViaEmailFail({
                error,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.shareProductCompareViaEmail,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                    },
                },
            }));
        })))));
    }
}
ShareProductCompareViaEmailEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShareProductCompareViaEmailEffects, deps: [{ token: i1$1.Actions }, { token: ShareProductCompareViaEmailService }], target: i0.ɵɵFactoryTarget.Injectable });
ShareProductCompareViaEmailEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShareProductCompareViaEmailEffects, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShareProductCompareViaEmailEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.Actions }, { type: ShareProductCompareViaEmailService }]; } });

/* istanbul ignore next */
class NgRxFileShareModule {
    constructor(ngRxFileShareLibConfig, store, panAppState, webSocketService) {
        this.ngRxFileShareLibConfig = ngRxFileShareLibConfig;
        this.store = store;
        this.panAppState = panAppState;
        this.webSocketService = webSocketService;
        this.subscripions = [];
    }
    static forRoot(ngRxFileShareLibConfig, store, panAppState, webSocketService) {
        return {
            ngModule: NgRxFileShareModule,
            providers: [
                {
                    provide: NGRX_FILESHARE_LIB_CONFIG,
                    useValue: ngRxFileShareLibConfig,
                },
            ],
        };
    }
}
NgRxFileShareModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NgRxFileShareModule, deps: [{ token: NGRX_FILESHARE_LIB_CONFIG }, { token: i1$2.Store }, { token: i2.PanAppState }, { token: i3.WebSocketService, optional: true }], target: i0.ɵɵFactoryTarget.NgModule });
NgRxFileShareModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: NgRxFileShareModule, imports: [i1$1.EffectsFeatureModule] });
NgRxFileShareModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NgRxFileShareModule, providers: [
        HttpClientService,
        SharePDPViaEmailEffects,
        SharePDPViaEmailService,
        ShareReviewOrderViaEmailEffects,
        ShareReviewOrderViaEmailService,
        ShareOrderConfirmationViaEmailEffects,
        ShareOrderConfirmationViaEmailService,
        ShareSubmittedOrderViaEmailEffects,
        ShareSubmittedOrderViaEmailService,
        ShareProductCompareViaEmailEffects,
    ], imports: [EffectsModule.forFeature([
            SharePDPViaEmailEffects,
            ShareReviewOrderViaEmailEffects,
            ShareOrderConfirmationViaEmailEffects,
            ShareSubmittedOrderViaEmailEffects,
            ShareProductCompareViaEmailEffects,
        ])] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NgRxFileShareModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [
                        EffectsModule.forFeature([
                            SharePDPViaEmailEffects,
                            ShareReviewOrderViaEmailEffects,
                            ShareOrderConfirmationViaEmailEffects,
                            ShareSubmittedOrderViaEmailEffects,
                            ShareProductCompareViaEmailEffects,
                        ]),
                    ],
                    providers: [
                        HttpClientService,
                        SharePDPViaEmailEffects,
                        SharePDPViaEmailService,
                        ShareReviewOrderViaEmailEffects,
                        ShareReviewOrderViaEmailService,
                        ShareOrderConfirmationViaEmailEffects,
                        ShareOrderConfirmationViaEmailService,
                        ShareSubmittedOrderViaEmailEffects,
                        ShareSubmittedOrderViaEmailService,
                        ShareProductCompareViaEmailEffects,
                    ],
                    exports: [],
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [NGRX_FILESHARE_LIB_CONFIG]
                }] }, { type: i1$2.Store }, { type: i2.PanAppState }, { type: i3.WebSocketService, decorators: [{
                    type: Optional
                }] }]; } });

// module

/**
 * Generated bundle index. Do not edit.
 */

export { NgRxFileShareModule, SHARE_ORDER_CONFIRMATION_EMAIL_ACTIONS, SHARE_PDP_EMAIL_ACTIONS, SHARE_PRODUCT_COMPARE_EMAIL_ACTIONS, SHARE_REVIEW_ORDER_EMAIL_ACTIONS, SHARE_SUBMITTED_ORDER_EMAIL_ACTIONS, ShareOrderConfirmationViaEmailEffects, ShareOrderConfirmationViaEmailService, SharePDPViaEmailEffects, SharePDPViaEmailService, ShareProductCompareViaEmailEffects, ShareProductCompareViaEmailService, ShareReviewOrderViaEmailEffects, ShareReviewOrderViaEmailService, ShareSubmittedOrderViaEmailEffects, ShareSubmittedOrderViaEmailService, TRACE_CONTEXT };
